import { useEffect, useMemo, type ReactNode } from 'react';
import { ThemeProvider } from 'stubben-edge-unified-frontend-react-components';
import { useStore } from '@hooks/useStore';
import {
  hydrateTenantBrandFont,
  setTenantBrandFont,
  useTenantBrandFont
} from '@/store/tenantBrandFont';

function BrandThemeProvider({ children }: { children: ReactNode }) {
  const { authStore } = useStore();
  const brandFont = useTenantBrandFont();
  const companyFont = authStore.user?.company?.font_family;

  useEffect(() => {
    hydrateTenantBrandFont();
  }, []);

  useEffect(() => {
    if (companyFont) {
      setTenantBrandFont(companyFont);
    }
  }, [companyFont]);

  const theme = useMemo(
    () => ({
      baseTheme: 'flightdeck',
      overrides: brandFont
        ? {
            '--font-family-body': `"${brandFont}", ui-sans-serif, system-ui, sans-serif`,
            '--font-family-headings': `"${brandFont}", ui-sans-serif, system-ui, sans-serif`
          }
        : undefined
    }),
    [brandFont]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default BrandThemeProvider;
